import { VisitNodePassage } from "../../types";
export const addStaticFieldVisitor = (measures) => (args) => {
    if (args?.context?.visitNodePassage !== VisitNodePassage.NodeLast || !args.visitable.data) {
        return;
    }
    const [field, rowNumber, label] = measures;
    const mm = args.visitable.data[rowNumber]?.measures;
    if (mm) {
        mm[field] = label;
    }
};
